module.exports = __webpack_public_path__ + "static/media/sms-active.1cafc0bf.svg";